// extracted by mini-css-extract-plugin
export default {"exerciseItem":"Exercise_exerciseItem__9i50I","textPreview":"Exercise_textPreview__4+mM2"};